import CircleIcon from "@mui/icons-material/Circle";
import { Alert, Box, Button, Tab, Tabs, Typography } from "@mui/material";
import { createMRTColumnHelper } from "material-react-table";
import { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import MDAlert from "../../components/MDAlert";
import MDTypography from "../../components/MDTypography";
import { AuthContext } from "../../context";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import apiService from "../../services/api-service";
import { tenant } from "../../tenant";
import GenericForm from "../genericForm";
import GenericTable from "../genericTable";
// GraphQL import removed - now using REST API

function UserInternalEdit() {
	const authContext = useContext(AuthContext);
	const [activeTab, setActiveTab] = useState(0);
	const { id } = useParams();
	const navigate = useNavigate();
	const columnHelper = createMRTColumnHelper();

	const handleChange = (event, newValue) => {
		setActiveTab(newValue);
	};

	const [personalData, setPersonalData] = useState({}); // Dati personali da query
	const [associatedAreaRolesData, setAssociatedAreaRolesData] = useState([]); // Dati delle aree associate
	const [contactsData, setContactsData] = useState([]); // Dati dei contatti
	const [showformAree, setShowFormAree] = useState(false);
	const [editAreaRole, setEditAreaRole] = useState(false);
	const [showFormContacts, setShowFormContacts] = useState(false);
	const [editContactsData, setEditContactsData] = useState({});
	const [editContacts, setEditContacts] = useState(false);
	const [editAreaRoleData, setEditAreaRoleData] = useState({});
	const [areeOption, setAreeOption] = useState([]);
	const [rolesOption, setRolesOption] = useState([]);
	const [contactsOption, setContactsOption] = useState([]);
	const [error, seterror] = useState("");

	function fetchPersonal() {
		apiService
			.get("/user-internal-management/", { id: id }, {})
			.then((data) => {
				setPersonalData({ ...data, id: id });
			})
			.catch((error) =>
				toast.error(
					"Errore durante il caricamento dei dati. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #00009",
					{ id: "user-internal-edit-toast" }
				)
			);
	}

	function fetchAreaRoles() {
		apiService
			.get("/user-management/area-roles/", { id_user: id, internal: true }, {})
			.then((data) => {
				let new_data = [];
				for (let i = 0; i < data.length; i++) {
					let temp = {
						...data[i],
						roles: data[i].roles.join(", "), // Unisce gli elementi dell'array 'auths' in una stringa
					};
					new_data.push(temp);
				}
				setAssociatedAreaRolesData(new_data);
			})
			.catch((error) =>
				toast.error(
					"Errore durante il caricamento dei dati. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #00007",
					{ id: "user-internal-edit-toast" }
				)
			);
	}

	function fetchContacts() {
		apiService
			.get("/user-management/contacts/", { id_user: id, internal: true }, {})
			.then((data) => {
				setContactsData(data);
			})
			.catch((error) =>
				toast.error(
					"Errore durante il caricamento dei dati. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #000016",
					{ id: "user-internal-edit-toast" }
				)
			);
	}

	useEffect(() => {
		/*
		 * FETCH DELLE OPZIONI DELLE AUTOCOMPLETE
		 */
		apiService
			.get("/area-management/", {}, {})
			.then((data) => {
				if (data) setAreeOption(data);
			})
			.catch((error) => {
				console.log(error);
				seterror(
					"Qualcosa è andato storto durante il caricamento delle autorizzazioni. Riprovare più tardi, se l'errore persiste contatti il supporto tecnico segnalando l'errore #00008"
				);
			});
		apiService
			.get("/role-management/", {}, {})
			.then((data) => {
				if (data) setRolesOption(data);
			})
			.catch((error) => {
				console.log(error);
				seterror(
					"Qualcosa è andato storto durante il caricamento dei ruoli. Riprovare più tardi, se l'errore persiste contatti il supporto tecnico segnalando l'errore #00010"
				);
			});
		apiService
			.get("/contacts/", {}, {})
			.then((data) => {
				setContactsOption(data);
			})
			.catch((error) =>
				seterror(
					"Errore durante il caricamento dei dati. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #00007"
				)
			);
		/*
		 * FINE FETCH DELLE OPZIONI DELLE AUTOCOMPLE
		 */

		fetchPersonal();
		//fetchAreaRoles() -> Non lo chiamo qua perchè tanto lo chiamo sempre nello useEffect di showformAree, che all'inizio sarà sempre a false e quindi lo chiamo sempre
		// fetchContacts() -> come spiegato sopra
	}, []);

	const handleSavePersonalData = (data) => {
		console.log("Salva Dati Personali:", data);
	};

	async function deleteResource(params, endpoint) {
		try {
			// Parametri opzionali per la richiesta DELETE
			const headers = {}; // Headers opzionali

			// Esegui la chiamata DELETE
			const response = await apiService.delete(endpoint, params, headers);

			// Se arriviamo qui, la chiamata è andata a buon fine
			console.log(`Risorsa con id ${id} eliminata con successo:`, response);

			// Puoi fare qualcosa con la risposta, se necessario
			return response;
		} catch (error) {
			// Gestisci eventuali errori
			console.error(`Errore durante l'eliminazione della risorsa con id ${id}:`, error.message);

			// Puoi gestire l'errore in modo specifico, ad esempio:
			if (error.message.includes("404")) {
				console.log(`La risorsa con id ${id} non è stata trovata`);
			} else if (error.message.includes("403")) {
				console.log(`Non hai i permessi per eliminare la risorsa con id ${id}`);
			}

			// Rilancia l'errore se vuoi che venga gestito a un livello superiore
			throw error;
		}
	}

	function handleDelete(id, endpoint, resource, errorCode, sezione) {
		deleteResource(id, endpoint)
			.then((result) => {
				toast.success(`${resource} eliminato con successo`, {
					id: "user-internal-edit-toast",
				});
				if (sezione === "area-roles") {
					fetchAreaRoles();
				} else if (sezione === "contacts") {
					fetchContacts();
				}
			})
			.catch((error) => {
				// Gestisci l'errore se non è stato gestito nella funzione
				toast.error(
					`Si è verificato un errore durante l'eliminazione del ${resource}. Riprova più tardi se l'errore persiste contatta il supporto tecnico indicato l'errore #${errorCode}`,
					{ id: "user-internal-edit-toast" }
				);
			});
	}

	const handleDeleteRow = (id_row, sezione) => {
		if (sezione === "area-roles") {
			handleDelete({ id_area: id_row, id_user: id, internal: true }, "/user-management/area-roles/", "area", "00013", sezione);
		} else if (sezione === "contacts") {
			handleDelete({ id_contact: id_row, id_user: id, internal: true }, "/user-management/contacts/", "contact", "00018", sezione);
		}
	};

	const handleEditRow = (id_row, sezione) => {
		if (sezione === "area-roles") {
			setEditAreaRole(true);
			apiService
				.get("/user-management/area-roles/", { id_user: id, id_area: id_row, internal: true }, {})
				.then((data) => {
					setEditAreaRoleData(data);
					setShowFormAree(true);
				})
				.catch((error) =>
					seterror(
						"Errore durante il caricamento dei dati. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #00007"
					)
				);
		} else if (sezione === "contacts") {
			setEditContacts(true);
			apiService
				.get("/user-management/contacts/", { id_user: id, id_contact: id_row, internal: true }, {})
				.then((data) => {
					setEditContactsData(data);
					setShowFormContacts(true);
				})
				.catch((error) =>
					seterror(
						"Errore durante il caricamento dei dati. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #00017"
					)
				);
		}
	};

	useEffect(() => {
		if (!showformAree) fetchAreaRoles();
	}, [showformAree]);

	useEffect(() => {
		if (!showFormContacts) fetchContacts();
	}, [showFormContacts]);

	return (
		<DashboardLayout>
			{authContext.hasAuth("EDIT_INTERNAL_USER") ? (
				<>
					<DashboardNavbar />
					<Box sx={{ width: "100%" }}>
						<Button
							variant="contained"
							color="primary"
							onClick={() => navigate("/users-internal-managment")}
							sx={{
								mt: 2,
								alignSelf: "center",
								minWidth: "100px",
								color: "#ffffff",
								marginBottom: "30px",
							}}
						>
							Torna alla tabella Operatori interni
						</Button>
						<Tabs value={activeTab} onChange={handleChange} centered>
							<Tab label="Dati personali" />
							<Tab
								label={
									<>
										<span>Commesse associate</span>
										<span>
											{associatedAreaRolesData.length === 0 && (
												<CircleIcon
													color="error"
													fontSize={"small"}
													sx={{
														color: "#B71C1C",
														marginLeft: "10px",
														marginTop: "6px",
													}}
												/>
											)}
										</span>
									</>
								}
							/>
							<Tab
								label={
									<>
										<span>Contatti</span>
										<span>
											{contactsData.length === 0 && (
												<CircleIcon
													color="error"
													fontSize={"small"}
													sx={{
														color: "#B71C1C",
														marginLeft: "10px",
														marginTop: "6px",
													}}
												/>
											)}
										</span>
									</>
								}
							/>
						</Tabs>

						<TabPanel value={activeTab} index={0}>
							<GenericForm
								old_data={personalData}
								authModelName={"INTERNAL_USER"}
								url="/user-internal-management/"
								useAPI={true} // cambia a true per usare l'API
								executeOnSuccess={true}
								executeOnSuccessTask={fetchPersonal}
								requiredFields={[
									{
										name: "first_name",
										nameDiplayed: "Nome",
									},
									{
										name: "last_name",
										nameDiplayed: "Cognome",
									},
									{
										name: "fiscal_code",
										nameDiplayed: "Codice fiscale",
									},
									{
										name: "date_of_birth",
										nameDiplayed: "Data di nascita",
									},
								]}
								inputFields={[
									{
										type: "text",
										name: "first_name", // Nome nel DB
										label: "Nome", // Etichetta visibile
									},
									{
										type: "text",
										name: "last_name", // Cognome nel DB
										label: "Cognome", // Etichetta visibile
									},
									{
										type: "text",
										name: "fiscal_code", // Codice fiscale nel DB
										label: "Codice Fiscale", // Etichetta visibile
									},
									{
										type: "date",
										name: "date_of_birth", // Data di nascita nel DB
										label: "Data di Nascita", // Etichetta visibile
										helperText: "Formato gg-mm-aaaa",
									},
								]}
							/>
						</TabPanel>

						<TabPanel value={activeTab} index={1}>
							{authContext.hasAuth("ADD_USERROLEAUTHAREA") ||
							(authContext.hasAuth("EDIT_USERROLEAUTHAREA") && showformAree) ? (
								<center>
									<Button
										variant="contained"
										color="info"
										onClick={() => {
											setShowFormAree(!showformAree);
											setEditAreaRole(false);
										}}
										sx={{
											mt: 2,
											alignSelf: "center",
											minWidth: "100px",
											color: "#000000",
											marginBottom: "30px",
											marginTop: "20px",
										}}
									>
										{showformAree ? "Torna alla tabella" : "Aggiungi"}
									</Button>
								</center>
							) : null}
							{error !== "" ? (
								<Alert severity="error">{error}</Alert>
							) : !showformAree ? (
								<GenericTable
									authModelName={"USERROLEAUTHAREA"}
									columns={[
										columnHelper.accessor("area_name", {
											header: "Area",
											size: 120,
										}),
										columnHelper.accessor("roles", {
											header: "Ruoli",
											size: 350,
											cell: (info) => {
												const words = info.getValue().split(/(?=[A-Z])/); // Separazione basata su maiuscole per "diodiavolo" -> ["dio", "diavolo"]
												return words.join(", "); // Unisce le parole con una virgola
											},
										}),
									]}
									data={associatedAreaRolesData}
									onDelete={(id) => handleDeleteRow(id, "area-roles")}
									onEdit={(id) => handleEditRow(id, "area-roles")}
								/>
							) : !editAreaRole ? (
								<GenericForm
									authModelName={"USERROLEAUTHAREA"}
									old_data={{ id_user: id, internal: true }}
									url="/user-management/area-roles/"
									useAPI={true}
									requiredFields={[
										{ name: "area", nameDiplayed: "area" },
										{
											name: "roles",
											nameDiplayed: "ruoli associati",
										},
									]}
									inputFields={[
										{
											type: "autocomplete",
											name: "area", // Nome nel DB
											label: "Area", // Etichetta visibile
											options: areeOption,
											valueToDisplay: (value, options) => {
												// Controlla se `value` è un oggetto
												if (typeof value === "object") {
													return `${value.name}`; // Mostra direttamente le informazioni
												}
												// Se `value` è un ID (numero)
												const option = options.find((opt) => opt.id === value); // Cerca l'opzione in base all'ID
												return option ? `${option.name}` : "area non trovata"; // Messaggio se non trovato
											},

											valueToSave: (selected) => {
												// Se `selected` è un array
												if (Array.isArray(selected)) {
													// Crea un insieme di ID esistenti per evitare duplicati
													const existingIds = new Set(
														selected.map((opt) => (typeof opt === "object" ? opt.id : opt))
													);

													// Aggiungi il nuovo ID solo se non è già presente
													return Array.from(existingIds);
												}

												// Se `selected` è un singolo oggetto, restituisci il suo ID
												return selected?.id;
											},
											valueComparator: (option, value) => {
												// Controlla se `value` è un numero (ID)
												if (typeof value === "number") {
													return option.id === value; // Confronta l'ID dell'opzione con il valore
												}

												// Se `value` è un oggetto, confronta l'ID
												return option.id === value.id; // Confronta l'ID dell'opzione con l'ID dell'oggetto value
											},
										},
										{
											type: "autocomplete",
											name: "roles", // Nome nel DB
											label: "Ruoli associati", // Etichetta visibile
											multiple: true,
											options: rolesOption,
											valueToDisplay: (value, options) => {
												// Controlla se `value` è un oggetto
												if (typeof value === "object") {
													return `${value.name}`; // Mostra direttamente le informazioni
												}
												// Se `value` è un ID (numero)
												const option = options.find((opt) => opt.id === value); // Cerca l'opzione in base all'ID
												return option ? `${option.name}` : "ruolo non trovato"; // Messaggio se non trovato
											},

											valueToSave: (selected) => {
												// Se `selected` è un array
												if (Array.isArray(selected)) {
													// Crea un insieme di ID esistenti per evitare duplicati
													const existingIds = new Set(
														selected.map((opt) => (typeof opt === "object" ? opt.id : opt))
													);

													// Aggiungi il nuovo ID solo se non è già presente
													return Array.from(existingIds);
												}

												// Se `selected` è un singolo oggetto, restituisci il suo ID
												return selected?.id;
											},
											valueComparator: (option, value) => {
												// Controlla se `value` è un numero (ID)
												if (typeof value === "number") {
													return option.id === value; // Confronta l'ID dell'opzione con il valore
												}

												// Se `value` è un oggetto, confronta l'ID
												return option.id === value.id; // Confronta l'ID dell'opzione con l'ID dell'oggetto value
											},
										},
									]}
								/>
							) : (
								<GenericForm
									authModelName={"USERROLEAUTHAREA"}
									old_data={{
										...editAreaRoleData,
										id_user: id,
										internal: true,
									}}
									url="/user-management/area-roles/"
									useAPI={true}
									requiredFields={[
										{ name: "area", nameDiplayed: "area" },
										{
											name: "roles",
											nameDiplayed: "ruoli associati",
										},
									]}
									inputFields={[
										{
											type: "autocomplete",
											name: "area", // Nome nel DB
											label: "Area", // Etichetta visibile
											options: areeOption,
											valueToDisplay: (value, options) => {
												// Controlla se `value` è un oggetto
												if (typeof value === "object") {
													return `${value.name}`; // Mostra direttamente le informazioni
												}
												// Se `value` è un ID (numero)
												const option = options.find((opt) => opt.id === value); // Cerca l'opzione in base all'ID
												return option ? `${option.name}` : "area non trovata"; // Messaggio se non trovato
											},

											valueToSave: (selected) => {
												// Se `selected` è un array
												if (Array.isArray(selected)) {
													// Crea un insieme di ID esistenti per evitare duplicati
													const existingIds = new Set(
														selected.map((opt) => (typeof opt === "object" ? opt.id : opt))
													);

													// Aggiungi il nuovo ID solo se non è già presente
													return Array.from(existingIds);
												}

												// Se `selected` è un singolo oggetto, restituisci il suo ID
												return selected?.id;
											},
											valueComparator: (option, value) => {
												// Controlla se `value` è un numero (ID)
												if (typeof value === "number") {
													return option.id === value; // Confronta l'ID dell'opzione con il valore
												}

												// Se `value` è un oggetto, confronta l'ID
												return option.id === value.id; // Confronta l'ID dell'opzione con l'ID dell'oggetto value
											},
										},
										{
											type: "autocomplete",
											name: "roles", // Nome nel DB
											label: "Ruoli associati", // Etichetta visibile
											multiple: true,
											options: rolesOption,
											valueToDisplay: (value, options) => {
												// Controlla se `value` è un oggetto
												if (typeof value === "object") {
													return `${value.name}`; // Mostra direttamente le informazioni
												}
												// Se `value` è un ID (numero)
												const option = options.find((opt) => opt.id === value); // Cerca l'opzione in base all'ID
												return option ? `${option.name}` : "ruolo non trovato"; // Messaggio se non trovato
											},

											valueToSave: (selected) => {
												// Se `selected` è un array
												if (Array.isArray(selected)) {
													// Crea un insieme di ID esistenti per evitare duplicati
													const existingIds = new Set(
														selected.map((opt) => (typeof opt === "object" ? opt.id : opt))
													);

													// Aggiungi il nuovo ID solo se non è già presente
													return Array.from(existingIds);
												}

												// Se `selected` è un singolo oggetto, restituisci il suo ID
												return selected?.id;
											},
											valueComparator: (option, value) => {
												// Controlla se `value` è un numero (ID)
												if (typeof value === "number") {
													return option.id === value; // Confronta l'ID dell'opzione con il valore
												}

												// Se `value` è un oggetto, confronta l'ID
												return option.id === value.id; // Confronta l'ID dell'opzione con l'ID dell'oggetto value
											},
										},
									]}
								/>
							)}
						</TabPanel>

						<TabPanel value={activeTab} index={2}>
							{authContext.hasAuth("ADD_USERCONTACT") || (authContext.hasAuth("EDIT_USERCONTACT") && setShowFormContacts) ? (
								<center>
									<Button
										variant="contained"
										color="info"
										onClick={() => {
											setShowFormContacts(!showFormContacts);
											setEditContacts(false);
										}}
										sx={{
											mt: 2,
											alignSelf: "center",
											minWidth: "100px",
											color: "#000000",
											marginBottom: "30px",
											marginTop: "20px",
										}}
									>
										{showFormContacts ? "Torna alla tabella" : "Aggiungi"}
									</Button>
								</center>
							) : null}
							{error !== "" ? (
								<Alert severity="error">{error}</Alert>
							) : !showFormContacts ? (
								<GenericTable
									authModelName="USERCONTACT"
									columns={[
										columnHelper.accessor("contact_type", {
											header: "Tipo contatto",
											size: 120,
										}),
										columnHelper.accessor("contact_value", {
											header: "Valore contatto",
											size: 120,
										}),
									]}
									data={contactsData}
									onDelete={(id) => handleDeleteRow(id, "contacts")}
									onEdit={(id) => handleEditRow(id, "contacts")}
								/>
							) : !editContacts ? (
								<GenericForm
									authModelName="USERCONTACT"
									old_data={{ id_user: id, internal: true }}
									url="/user-management/contacts/"
									useAPI={true}
									requiredFields={[
										{
											name: "contact_type",
											nameDiplayed: "Tipologia del contatto",
										},
										{
											name: "contact_value",
											nameDiplayed: "Valore del contatto",
										},
									]}
									inputFields={[
										{
											type: "autocomplete",
											name: "contact_type", // Nome nel DB
											label: "Tipologia del contatto", // Etichetta visibile
											options: contactsOption,
											valueToDisplay: (value, options) => {
												// Controlla se `value` è un oggetto
												if (typeof value === "object") {
													return `${value.name}`; // Mostra direttamente le informazioni
												}
												// Se `value` è un ID (numero)
												const option = options.find((opt) => opt.id === value); // Cerca l'opzione in base all'ID
												return option ? `${option.name}` : "area non trovata"; // Messaggio se non trovato
											},

											valueToSave: (selected) => {
												// Se `selected` è un array
												if (Array.isArray(selected)) {
													// Crea un insieme di ID esistenti per evitare duplicati
													const existingIds = new Set(
														selected.map((opt) => (typeof opt === "object" ? opt.id : opt))
													);

													// Aggiungi il nuovo ID solo se non è già presente
													return Array.from(existingIds);
												}

												// Se `selected` è un singolo oggetto, restituisci il suo ID
												return selected?.id;
											},
											valueComparator: (option, value) => {
												// Controlla se `value` è un numero (ID)
												if (typeof value === "number") {
													return option.id === value; // Confronta l'ID dell'opzione con il valore
												}

												// Se `value` è un oggetto, confronta l'ID
												return option.id === value.id; // Confronta l'ID dell'opzione con l'ID dell'oggetto value
											},
										},
										{
											type: "text",
											name: "contact_value", // Nome nel DB
											label: "Valore del contatto", // Etichetta visibile
										},
									]}
								/>
							) : (
								<GenericForm
									authModelName="USERCONTACT"
									old_data={{
										...editContactsData,
										id_user: id,
										internal: true,
									}}
									url="/user-management/contacts/"
									useAPI={true}
									requiredFields={[
										{
											name: "contact_type",
											nameDiplayed: "Tipologia del contatto",
										},
										{
											name: "contact_value",
											nameDiplayed: "Valore del contatto",
										},
									]}
									inputFields={[
										{
											type: "autocomplete",
											name: "contact_type", // Nome nel DB
											label: "Tipologia del contatto", // Etichetta visibile
											options: contactsOption,
											valueToDisplay: (value, options) => {
												// Controlla se `value` è un oggetto
												if (typeof value === "object") {
													return `${value.name}`; // Mostra direttamente le informazioni
												}
												// Se `value` è un ID (numero)
												const option = options.find((opt) => opt.id === value); // Cerca l'opzione in base all'ID
												return option ? `${option.name}` : "area non trovata"; // Messaggio se non trovato
											},

											valueToSave: (selected) => {
												// Se `selected` è un array
												if (Array.isArray(selected)) {
													// Crea un insieme di ID esistenti per evitare duplicati
													const existingIds = new Set(
														selected.map((opt) => (typeof opt === "object" ? opt.id : opt))
													);

													// Aggiungi il nuovo ID solo se non è già presente
													return Array.from(existingIds);
												}

												// Se `selected` è un singolo oggetto, restituisci il suo ID
												return selected?.id;
											},
											valueComparator: (option, value) => {
												// Controlla se `value` è un numero (ID)
												if (typeof value === "number") {
													return option.id === value; // Confronta l'ID dell'opzione con il valore
												}

												// Se `value` è un oggetto, confronta l'ID
												return option.id === value.id; // Confronta l'ID dell'opzione con l'ID dell'oggetto value
											},
										},
										{
											type: "text",
											name: "contact_value", // Nome nel DB
											label: "Valore del contatto", // Etichetta visibile
										},
									]}
								/>
							)}
						</TabPanel>
					</Box>
				</>
			) : (
				<MDAlert color="error" dismissible>
					<MDTypography variant="body2">You don't have permission to access this page</MDTypography>
				</MDAlert>
			)}
		</DashboardLayout>
	);
}

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div role="tabpanel" hidden={value !== index} id={`tabpanel-${index}`} aria-labelledby={`tab-${index}`} {...other}>
			{value === index && (
				<Box sx={{ p: 3 }}>
					<Typography component="div">{children}</Typography>
				</Box>
			)}
		</div>
	);
}

export default UserInternalEdit;
